/* eslint-disable max-classes-per-file */
import Enum from '@rover/shared/js/types/Enum';

import MQ from './MediaQuery';

export class HeaderSize extends Enum<{
  SM_UP: string;
  XS: string;
}> {
  static h1 = new HeaderSize({
    SM_UP: '40px',
    XS: '36px',
  });

  static h2 = new HeaderSize({
    SM_UP: '32px',
    XS: '28px',
  });

  static h3 = new HeaderSize({
    SM_UP: '26px',
    XS: '22px',
  });

  static h4 = new HeaderSize({
    SM_UP: '20px',
    XS: '18px',
  });

  static h5 = new HeaderSize({
    SM_UP: '16px',
    XS: '16px',
  });

  static h6 = new HeaderSize({
    SM_UP: '14px',
    XS: '16px',
  });

  static isLocked = true;
}
export class HeaderWeight extends Enum<string> {
  static h1 = new HeaderWeight('400');

  static h2 = new HeaderWeight('400');

  static h3 = new HeaderWeight('400');

  static h4 = new HeaderWeight('400');

  static h5 = new HeaderWeight('400');

  static h6 = new HeaderWeight('400');

  static isLocked = true;
}
export class HeaderFontFamily extends Enum<string> {
  static h1 = new HeaderFontFamily(
    "'Averta-Extrabold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static h2 = new HeaderFontFamily(
    "'Averta-Extrabold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static h3 = new HeaderFontFamily(
    "'Averta-Semibold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static h4 = new HeaderFontFamily(
    "'Averta-Semibold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static h5 = new HeaderFontFamily(
    "'Averta-Semibold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static h6 = new HeaderFontFamily(
    "'Averta-Semibold', Averta, Helvetica Neue, Helvetica, sans-serif"
  );

  static isLocked = true;
}
export const HEADER_LINE_HEIGHT = '1.4';
export const HEADER_STYLES = Array(6)
  .fill(null)
  .map(
    (e, i) => `
    h${i + 1} {
      font-family: ${HeaderFontFamily[`h${i + 1}`]};
      font-weight: ${HeaderWeight[`h${i + 1}`]};
      line-height: ${HEADER_LINE_HEIGHT};
      ${MQ.SM_UP} {
        font-size: ${HeaderSize[`h${i + 1}`].value.SM_UP};
      }
      ${MQ.XS} {
        font-size: ${HeaderSize[`h${i + 1}`].value.XS};
      }
    }
  `
  )
  .join('');

const Headers = {
  HeaderSize,
  HeaderWeight,
  HEADER_LINE_HEIGHT,
  HEADER_STYLES,
};

export default Headers;



// WEBPACK FOOTER //
// ../kibble/styles/Headers.ts